import React from "react";
import "./incrementer.component.scoped.sass";
import { IncrementerProps } from "src/types/incrementer-props";
import IconButton from "@material-ui/core/IconButton/IconButton";

export default function Incrementer(props: IncrementerProps) {
  const { actionFunction, count } = props;
  return (
    <div className="incrementer">
      <IconButton
        onClick={actionFunction.bind(null, "dec")}
        color="primary"
        className="dec"
        aria-label="upload picture"
        component="span"
      >-</IconButton>
      <div className="count">{count}</div>
      <IconButton
        onClick={actionFunction.bind(null, "inc")}
        color="primary"
        className="inc"
        aria-label="upload picture"
        component="span"
      >+</IconButton>
    </div>
  );
}
